import { render, staticRenderFns } from "./ArticleUploadPdf.vue?vue&type=template&id=b71e4d2c"
import script from "./ArticleUploadPdf.vue?vue&type=script&lang=js"
export * from "./ArticleUploadPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports